export * from './IMarketingLink';
export * from './IUpdateMarketingLink';
export * from './IMarketingLinkData';
export * from './ILinkResponse';
